import React, { useState, useEffect, useCallback } from 'react';
import Traductor from '../../components/Traductor';
import Input from '../bronson/Input';
import Button from '../bronson/Button';
import {
    formatPrice,
    formatNumber,
} from '../../js/components/shared/vehicleFunctions';
import { checkValidBidFormat } from '../../js/components/shared/vehicleFunctions';
import { disableHTMLOverflow } from '../../Functions';

import sameBidSVG from '../../images/icons/user-same-bid-icon.svg';
import '../../css/components/auctions/modalSameBid.css';

function ModalSameBid({ options, closeModal, validateNewBid }) {
    const t = new Traductor();
    const [ariaHidden, setAriaHidden] = useState('false');
    const [proposalMaxBid, setProposalMaxBid] = useState(0);
    const [bidValue, setBidValue] = useState(0);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [messageBidNotAcepted, setMessageBidNotAcepted] = useState(false);

    useEffect(() => {
        disableHTMLOverflow(true);
        let newValue =
            parseInt(options.sameAmount) + parseInt(options.differentialAmount);
        setProposalMaxBid(newValue);
        setBidValue(newValue);
    }, [options.sameAmount]);

    let optionsInput = {
        id: 'modalsamebidinput',
        type: 'text',
        name: 'modalsamebidinput',
        event: true,
        className: 'c-input__input--blue-border',
        disabled: loadingRequest,
        customAttributes: {
            context: 'surname',
        },
        value: proposalMaxBid,
        placeHolder: t.getTraduction('YoutMaximumBidHere'),
    };

    let optionsBtnPujar = {
        class: 'c-btn--full c-btn--primary-b',
        text: t.getTraduction('BidUp'),
        btnTypes: ['secondary'],
        disabled: loadingRequest || bidValue < proposalMaxBid,
    };

    const onChange = e => {
        const value = e.target.value.replace(/[^\d]/g, '');
        setBidValue(value);
    };

    const formatThousands = useCallback(value => {
        if (!value) return value;

        const resetValue = value.toString().replaceAll('.', '');

        return formatNumber(resetValue);
    }, []);

    const closeThisModal = () => {
        disableHTMLOverflow(false);
        setAriaHidden('true');
        closeModal({});
    };

    const setNewBid = async () => {
        if (checkValidBidFormat(bidValue)) {
            setLoadingRequest(true);
            if (bidValue >= proposalMaxBid) {
                let correct = await validateNewBid(bidValue);
                if (correct) {
                    closeThisModal();
                } else {
                    setMessageBidNotAcepted(true);
                }
            } else {
                alert(
                    'Por favor, pon una cifra superior para poder enviar tu puja.'
                );
            }
            setLoadingRequest(false);
        } else {
            alert(
                'Formato no válido. Las pujas tienen que ser múltiples de 100. Cambia el valor introducido para seguir pujando.'
            );
        }
    };

    const printModalBody = () => {
        if (!messageBidNotAcepted) {
            return (
                <>
                    <p>
                        {t.getTraduction('ModalSameBid_Body') +
                            formatPrice(
                                options.maxBidInput ? options.maxBidInput : 0
                            ) +
                            '.'}
                    </p>
                    <p className="u-mb">
                        <strong>
                            {t.getTraduction('ModalSameBid_Body_2') +
                                formatPrice(
                                    options.differentialAmount
                                        ? options.differentialAmount
                                        : 0
                                ) +
                                '.'}
                        </strong>
                    </p>
                    <div className="o-layout" style={{ marginLeft: 0 }}>
                        <div className="o-layout__item u-2/3 u-p-none">
                            <Input
                                options={optionsInput}
                                onChange={e => onChange(e)}
                                value={formatThousands(bidValue)}
                            />
                        </div>
                        <div className="o-layout__item u-1/3 u-p-none">
                            <Button
                                options={optionsBtnPujar}
                                onClick={setNewBid}
                            />
                        </div>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <p>{t.getTraduction('ModalSameBid_Error')} </p>
                </>
            );
        }
    };

    return (
        <div
            className="c-modal c-modal--same-bid"
            aria-hidden={ariaHidden}
            id="modal-same-bid"
        >
            <div
                className="c-modal__overlay  js-modal-close"
                tabIndex="-1"
            ></div>
            <div
                className="c-modal__wrapper"
                role="dialog"
                aria-labelledby="modal-same-bid-title"
            >
                <header className="c-modal__header">
                    <button
                        className="c-modal__close-btn  js-modal-close"
                        type="button"
                        aria-label="Cerrar modal."
                        onClick={closeThisModal}
                    ></button>
                    <div className="c-modal__title__wrapper">
                        <img src={sameBidSVG} alt="Same Bid Logo" />
                        <h1
                            className="c-modal__title"
                            id="modal-same-bid-title"
                        >
                            {' '}
                            {t.getTraduction('ModalSameBid_Title')}
                        </h1>
                    </div>
                </header>
                <div className="c-modal__content" role="document">
                    {printModalBody()}
                </div>
                <div className="c-modal__footer">
                    <div className="c-modal__actions">
                        <div className="c-modal__actions__item">
                            <button
                                className={
                                    'c-btn js-modal-close ' +
                                    (!messageBidNotAcepted
                                        ? 'c-btn--secondary'
                                        : '')
                                }
                                aria-label="Go to preferences."
                                onClick={closeThisModal}
                            >
                                <span className="c-btn__text">
                                    {!messageBidNotAcepted
                                        ? t.getTraduction('Cancelar')
                                        : t.getTraduction('VolverAlListado')}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalSameBid;
